import { createRootRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { Toaster } from '@/shared/components/ui/toaster'
import { applyTheme } from '@/shared/components/ThemeToggle'

function RootComponent() {
  useEffect(() => {
    applyTheme((localStorage.getItem('theme') as 'light' | 'dark' | 'system') ?? 'system')
  }, [])

  return (
    <>
      <Outlet />
      <Toaster />
    </>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})
